// lc-hover-gallery.js
(function () {

  function showImage(gallery, index) {
    var imgs = gallery.querySelectorAll('.lc-hover-gallery__img');
    for (var i = 0; i < imgs.length; i++) {
      if (i === index) {
        imgs[i].classList.add('is-active');
      } else {
        imgs[i].classList.remove('is-active');
      }
    }
  }

  function updateProgress(gallery, index, count) {
    var bars = gallery.querySelectorAll('.lc-progress__bar');
    for (var i = 0; i < bars.length; i++) {
      bars[i].classList.remove('is-active', 'is-anim', 'is-complete');
      if (i < index) {
        bars[i].classList.add('is-complete');
      } else if (i === index) {
        bars[i].classList.add('is-active');
        // force reflow so animation restarts
        void bars[i].offsetWidth;
        bars[i].classList.add('is-anim');
      }
    }
  }

  function initGallery(gallery) {
    if (gallery.getAttribute('data-lc-hover-init')) return;
    gallery.setAttribute('data-lc-hover-init', '1');

    var imgs = gallery.querySelectorAll('.lc-hover-gallery__img');
    var count = imgs.length;
    if (count < 2) return; // nada que rotar

    var interval = parseInt(gallery.getAttribute('data-interval') || '1500', 10);
    var timer = null;
    var currentIndex = 0;

    gallery.addEventListener('mouseenter', function () {
      currentIndex = 0;
      showImage(gallery, currentIndex);
      updateProgress(gallery, currentIndex, count);

      timer = setInterval(function () {
        currentIndex = (currentIndex + 1) % count;
        showImage(gallery, currentIndex);
        updateProgress(gallery, currentIndex, count);
      }, interval);
    });

    gallery.addEventListener('mouseleave', function () {
      if (timer) clearInterval(timer);
      timer = null;
      currentIndex = 0;
      showImage(gallery, 0);
      // reset progress bars
      var bars = gallery.querySelectorAll('.lc-progress__bar');
      for (var i = 0; i < bars.length; i++) {
        bars[i].classList.remove('is-active', 'is-anim', 'is-complete');
      }
    });
  }

  function initAll() {
    var galleries = document.querySelectorAll('[data-lc-hover-gallery]');
    for (var i = 0; i < galleries.length; i++) {
      initGallery(galleries[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  var observer = new MutationObserver(function (mutations) {
    for (var m = 0; m < mutations.length; m++) {
      var nodes = mutations[m].addedNodes;
      for (var n = 0; n < nodes.length; n++) {
        if (nodes[n].querySelectorAll) {
          var newGalleries = nodes[n].querySelectorAll('[data-lc-hover-gallery]');
          for (var g = 0; g < newGalleries.length; g++) {
            initGallery(newGalleries[g]);
          }
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

})();